import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultConstruction,
  defaultDescription,
  useManualAndInternationalAddress,
  usePurchasePriceOnRequestCondition,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const agentHouseSellSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  objectNumbers: {
    groupNumber: validationRules.groupNumber,
  },
  basicInfo: {
    room: validationRules.room,
    livingSpace: validationRules.livingSpace,
    plotArea: validationRules.plotArea,
    price: usePurchasePriceOnRequestCondition,
    courtage: validationRules.courtage,
    courtageNote: validationRules.courtageNote,
  },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  construction: defaultConstruction,
  otherFacilities: {
    totalFloorsNumber: validationRules.totalFloors,
    noBathrooms: validationRules.noBathrooms,
    noBedrooms: validationRules.noBedrooms,
    usableArea: validationRules.usableArea,
    rentalIncome: validationRules.rentalIncome,
    parkingSpaceRent: validationRules.parkingSpaceRent,
    noParkingSpaces: validationRules.noParkingSpaces,
  },
}
